import Forms from "../../../../app/Components/Forms/Forms";
import App from "../../../../app/App";
import Layout from "../../../../views/Layout/Layout";

const ChangeEmail = {

    init() {

        this.el = $('[component="ChangeEmail"]');
        this.form = this.el.find("form");

        if (!this.el.length) {
            return;
        }

        this.checkboxes = $('[component="Checkbox"] input');
        this.submitButton = this.el.find('button[type="submit"]');

        Forms.init(this.form);
        Forms.focusFirstInput(this.form);
        Forms.setButtonPulseAfterEdit();
        Forms.setFormSubmitButton(this.submitButton);

        this.bind();
    },

    bind() {
        this.form.submit((event) => {
            Forms.setSendData( Forms.inputData(ChangeEmail.form) );
        });

        this.checkboxes.on("change", function (element) {

            let checkbox = $(this);
            let parent = $(checkbox).parents('[component="Checkbox"]');

            if ( $(parent).is('.disabled')) {
                console.warn("Checkbox disabled, waiting for response.");
                return;
            }

            clearTimeout(App.ajaxSendProtection);

            App.ajaxSendProtection = setTimeout(() => {

                $(parent).addClass("disabled");

                let button = $(checkbox).data();
                let value = $(checkbox).is(":checked");

                if ( !button ) {
                    console.warn("Missing ajax job")
                    return;
                }

                App.showLoading();
                App.ajax(
                    button.library,
                    button.event,
                    {
                        value: value
                    },
                    (response) => {
                        setTimeout(() => {
                            $(parent).removeClass("disabled");
                        }, 1000);
                    }
                )

                Layout.hideModal(this.dialog);
            }, 500);
        });
    },

}
export default ChangeEmail;